// JS file for ArticleList
